export const EnvConstants: { [key: string]: string | undefined } = {
  dlLinkedInUrl: process.env.GATSBY_LINKEDIN_URL,
  dlTwitterUrl: process.env.GATSBY_TWITTER_URL,
  dlFacebookUrl: process.env.GATSBY_FACEBOOK_URL,
  dlInstagramUrl: process.env.GATSBY_INSTAGRAM_URL,
  dlGlassdoorUrl: process.env.GATSBY_GLASSDOOR_URL,
  dlPhoneNumber: process.env.GATSBY_PHONE_NUMBER,
  dlEmail: process.env.GATSBY_EMAIL,
  dlBaseUrl: process.env.GATSBY_BASE_URL,
  dlCalendlyUrl: process.env.GATSBY_CALENDLY_URL,
};
